import React, { useEffect, useState }from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
// import useSWR from 'swr'
// import { getData } from '../components/sfc/component-helpers/requesthelpers'
import Layout from '../components/layout'
import WCMImage from '../components/sfc/wcmimage'
import DropCap from '../components/sfc/dropcap'
import { useCanNativeLazyLoad } from '../components/sfc/component-helpers/customhooks'
import Topper from '../components/sfc/topper'
import { ConvertTimestamp } from '../components/sfc/component-helpers/convertTimestamp'
import RelatedSection from '../components/sfc/relatedsection'
import CreditsSection from '../components/sfc/creditssection'
import Ad from '../components/sfc/ad'
import BodyText from '../components/sfc/bodytext'

// import Newsletter from '../components/sfc/newsletter'
import AthleteList from '../components/athletelist'
import SafeLink from '../components/sfc/safelink'
import Voting from '../components/voting'
import SponsorBug from '../components/sfc/sponsorbug'
import { applyScrollDepthTracking } from '../components/sfc/component-helpers/utilfunctions'
let storySettings = require('../data/story_settings.sheet.json')
let athlete_list = require(`../data/athletes.sheet.json`)
storySettings = storySettings[0]
if(athlete_list[0].Name.includes("full name")){
  athlete_list.shift()
  }
let rawCredits;
try {
	rawCredits = require('../data/credits.sheet.json')
} catch (err){
    // It's fine
    rawCredits = null;
}
let related_links;
try{
  related_links = require('../data/links.sheet.json')
} catch(err){
  related_links = require('../data/sfc/related_links.json')
}

const SurveyPage = ({ pageContext, data }) => {
  const [voted, setVoted] = useState(false)
  const [pageWinner, setPageWinner] = useState(null)
  const [multipleWinners, setMultipleWinners] = useState(false)
  useEffect(() => {
    // Set up scroll analytics
    applyScrollDepthTracking()
  }, [])
  const pageAthletes = athlete_list.filter(i => i.Page_Date === pageContext.page.Page_Date)
  useEffect(() => {
    if(pageContext.page.winner_announced === "TRUE"){
      let winners = pageAthletes.filter(i => i.winner == 'TRUE')
      console.log(winners)
      let winner;
      if(winners.length > 1){
          let winnerArray = []
          for(let w of winners){
              winnerArray.push(w.Name)
          }
          let winnerString = winnerArray.join(' and ')
          setPageWinner(winnerString)
          setMultipleWinners(true)
      }
      else{
          winner = pageAthletes.find(i => i.winner == 'TRUE')
          setPageWinner(winner.Name)
      }
}
  })


  const closeDate = (new Date(pageContext.page.Poll_Close))
  let today = new Date().getTime()
  let closeDateParsed = new Date(closeDate).getTime()
  const closed = (ConvertTimestamp(closeDateParsed) < today)
  // athlete_list.filter(i => i.Page_Slug == pageContext.Page_Slug)
  const [athleteChoice, setAthleteChoice] = useState(null)
  // easy hooks based request library
  // const { data: responseData, error } = useSWR('https://api.kanye.rest', getData, {
  //   onSuccess: (data) => console.log(data),
  //   onError: (err) => console.log(err),
  // })

  // custom hook checks for nativelazyload
  const lazy = useCanNativeLazyLoad()

	//check if there's a sponsor
	const has_sponsor = (storySettings.Is_Sponsored === true || storySettings.Is_Sponsored === "TRUE")
	console.log(pageContext)

  const {
    site: { siteMetadata },
    allRelatedLinksJson: { nodes: relatedLinks },
  } = data

  return (
    <Layout meta={siteMetadata} url_add={String((Date.parse(new Date(pageContext.page.Page_Date))))}>
      <Topper meta={siteMetadata} pageContext={pageContext.page} url_add={String((Date.parse(new Date(pageContext.page.Page_Date))))}/>
      <main>
        <article>
				{has_sponsor && <SponsorBug />}
        <BodyText
        text = {storySettings.Intro_graf}
        />

        <div className='aotw-links'>
        {storySettings.switch_link_one && <SafeLink withinSite={false} href={storySettings.switch_link_one}>{storySettings.switch_link_one_text}</SafeLink>}
        {storySettings.switch_link_two && <SafeLink withinSite={false} href={storySettings.switch_link_two}>{storySettings.switch_link_two_text}</SafeLink>}
        {storySettings.voting_rules && <SafeLink withinSite={false} href={storySettings.voting_rules}>{storySettings.voting_rules_text}</SafeLink>}
        <SafeLink href='/' withinProject={true}>{storySettings.hub_link_text}</SafeLink>
        </div>

          {closed && pageContext.page.winner_announced == "FALSE" && <h3 className='voting-status'>Voting has closed. Check back soon to see the winner.</h3>}
          {pageContext.page.winner_announced == "TRUE" && <h3 className='voting-status'> {(multipleWinners ? 'Voting has closed. The winners are ' : 'Voting has closed. The winner is ') + pageWinner + "!"}</h3>}

        <AthleteList already_voted={voted} closeDate={(new Date(pageContext.page.Poll_Close))} winner_announced={pageContext.page.winner_announced}page_slug={parseInt(Date.parse(new Date(pageContext.page.Page_Date)))} setStoryChoice={setAthleteChoice} theme_color={storySettings.theme_color ? storySettings.theme_color : '#B1C097'}/>


          {/* <Newsletter /> */}
        {!closed && <Voting voted={voted} setVoted={setVoted} storyChoice={athleteChoice} setStoryChoice={setAthleteChoice} pollPrefix={storySettings.Poll_prefix} theme_color={storySettings.theme_color ? storySettings.theme_color : '#B1C097'} poll_date={parseInt(Date.parse(new Date(pageContext.page.Page_Date)))}/>}
      <Ad adLetter={'B'} />
      </article>
      </main>

      <RelatedSection links={related_links} />
      <CreditsSection />
    </Layout>
  )
}

export const query = graphql`
  {
    site {
      siteMetadata {
        EMBEDDED
        MAIN_DOMAIN
        PAYWALL_SETTING
        PROJECT {
          AUTHORS {
            AUTHOR_NAME
            AUTHOR_PAGE
          }
          DATE
          DESCRIPTION
          HEARST_CATEGORY
          KEY_SUBJECTS
          DISPLAY_TITLE
          IMAGE
          ISO_MODDATE
          ISO_PUBDATE
          OPT_SLASH
          SLUG
          SOCIAL_TITLE
          SUBFOLDER
          TITLE
          TWITTER_TEXT
          ANALYTICS_CREDIT
          MARKET_KEY
          CANONICAL_URL
        }
      }
    }
    allRelatedLinksJson {
      nodes {
        wcmid
        title
        url
      }
    }
  }
`

export default SurveyPage
